import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { PledgePerWinService } from '../../_services/fundraising/pledgePerWin.service';
import { PledgePerWin } from '../../_models/fundraising/ppw/PledgePerWin';
import { forkJoin, of } from 'rxjs';
import { Payout, PayoutGroup } from '../../_models/fundraising/Payout';
import { Event } from '../../_models/fundraising/Event';

@Component({
  selector: 'app-ppw-payout-management',
  templateUrl: './ppw-payout-management.component.html',
  styleUrls: ['../fundraising-management.component.css', './ppw-payout-management.component.css']
})

export class PledgePerWinPayoutManagementComponent implements OnInit  {

  loading = false;
  searchText: string;

  public payouts: Payout[] = [];
  public payoutGroups: PayoutGroup[] = [];
  public displayItems: Payout[] = [];
  public events: Event[] = [];

  public selectedCampaign = 0;

  private bsModalRef: BsModalRef;

  constructor(
    private ppwService: PledgePerWinService,
    private router: Router,
    private viewRef: ViewContainerRef,
    private dialogService: DialogService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService
  ) { }

  ngOnInit () {

    this.loadGames();
  }

  loadGames () {

    this.loading = true;
    this.spinner.show();

    this.ppwService.getAllPayouts()
        .subscribe(
            data => {

                this.payouts = data;
                this.payoutGroups = this.createPayoutGroups([...this.payouts], null);
                const allEvents = data.map(p => p.event);
                this.events = [...new Map(allEvents.map(e => [e.eventId, e])).values()];

                this.loading = false;
                this.spinner.hide();
            },
            error => {

                this.loading = false;
                this.spinner.hide();

                if (!error) return;

                this.dialogService.alert(
                    'Uh oh something went wrong...',
                    `Unable to load payouts: ${error.error}`,
                    this.viewRef);

            }
        );
  }

  filterByCampaign () {

    this.payoutGroups = this.createPayoutGroups([...this.payouts], null);

    if (+this.selectedCampaign === 0){

      return;
    }

    this.payoutGroups = this.payoutGroups.filter(g => g.children[0].event.eventId === +this.selectedCampaign);
  }

  public search() {

    this.payoutGroups = this.createPayoutGroups([...this.payouts], null);

    if (!this.searchText) {

      return;
    }

    let quoteRegex = /[^\s"]+|"([^"]*)"/gi;
    let searchTerms = [];
    let match;

    do {

      match = quoteRegex.exec(this.searchText.toLowerCase());

      if (match != null) {

        searchTerms.push(match[1] ? match[1] : match[0]);
      }

    } while (match != null);

    this.payoutGroups = this.createPayoutGroups([...this.payouts], searchTerms)
  }

  public createPayoutGroups (payouts: Payout[], filters: string[] = null) : PayoutGroup[] {

    const groups = payouts.reduce(
      (r, e) => {

        // Find the group this payout belongs
        let group = e.event.name;

        const match = (filters && filters.some(f => e.event.name.toLowerCase().indexOf(f) > -1) || !filters);

        // If there's no group for this payout yet, we are filtering and the event name matches the search term, or we aren't filtering, create a new group and add payout as child
        if (!r[group] && match) {

          r[group] = {group, children: [e]} as PayoutGroup;

        // If there is a group for this payout, we are filtering and the event name matches the search term, or we aren't filtering, add this payout to children of the group
        } else if (r[group] && match) {

          r[group].children.push(e);
        }

        return r;
      }, {});

    const payoutGroups = Object.values(groups) as PayoutGroup[];

    // Sort the payouts in each group by date completed
    for(let group of payoutGroups) {

      group.children = group.children.sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
    }

    // Sort each group by the most recent payout
    payoutGroups.sort((a, b) => new Date(b.children[0].dateCreated).getTime() - new Date(a.children[0].dateCreated).getTime());

    let completedGroups = [];

    // Find out which groups are campaigns that have been completed or cancelled
    for(let group of payoutGroups) {

      if (group.children[0].event.status > 2) {

        const idx = payoutGroups.indexOf(group);
        completedGroups = completedGroups.concat(payoutGroups.splice(idx, 1));
      }
    }

    // Put the completed campaigns at the end of the list
    return payoutGroups.concat(completedGroups);
  }
}
